import {
    FGSelect,
    components,
    OptionProps,
    FGSelectOption,
    FGTile,
    FGStack,
    FGCheckbox,
    FGTypography,
    FGIcons,
} from '@fg/design-system';
import { effectOptions } from 'components/scoringPage/consts';
import { map, get, toString, toNumber } from 'lodash/fp';
import { inject } from 'mobx-react';
import rootStore, { IMobxRootState } from 'RootStore';
import { EventCircle } from './EventCircle';

type Props = {
    impactFilter?: number[];
};
const ImpactFilter = inject(({ eventsFeedStore }: IMobxRootState) => {
    return {
        impactFilter: eventsFeedStore.impactFilter,
    };
})(({ impactFilter }: Props) => {
    return (
        <FGSelect
            className="impact-filter-select"
            isMulti
            placeholder="Impact"
            value={impactFilter.map(impact => ({
                //todo: fix
                value: toString(impact),
                label: effectOptions.find(imp => imp.value === impact).text,
            }))}
            onChange={newSelectedValues => {
                rootStore.eventsFeedStore.setImpactFilter(
                    //todo: fix TS types
                    //@ts-ignore
                    newSelectedValues.map(val => toNumber(val.value))
                );
            }}
            options={map(
                impact => ({
                    value: toString(impact.value),
                    label: impact.text,
                    color: impact.color,
                }),
                effectOptions
            )}
            components={{
                Option: ImpactOption,
                MultiValue: CustomMultiValue,
                Control: ControlComponent,
            }}
        />
    );
});

const ControlComponent = (props: any) => {
  return (
      <components.Control {...props}>
          <FGIcons icon="DataTools" style={{ marginRight: 8 }} data-testid="feed-impact-filter" />
          {...props.children}
      </components.Control>
  );
};

const CustomMultiValue = (props: any) => {
    return (
        <FGTile
            padding="small"
            appearance="primary"
            style={{
                marginRight: 4,
                marginBottom: 4,
                width: 'auto',
                padding: '4px 8px',
            }}>
            <components.MultiValue {...props}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                    <ImpactMultiValue {...props} />
                </div>
            </components.MultiValue>
        </FGTile>
    );
};

const ImpactMultiValue = (props: any) => {
    const impact = toNumber(props.data?.value);
    const effectOption = effectOptions.find(imp => imp.value === impact);
    return (
        <FGTile padding="none" appearance="primary">
            <FGStack alignItems="center" gap={4}>
                <EventCircle color={effectOption.color} radius={8} />
                <FGTypography
                    variant="body4"
                    tag="label"
                    color="strong"
                    cssStyle={{ pointerEvents: 'none' }}>
                    {effectOption.text}
                </FGTypography>
            </FGStack>
        </FGTile>
    );
};
const ImpactOption: React.ComponentType<OptionProps<
    FGSelectOption
>> = props => {
    const { label, isSelected, data } = props;
    return (
        <FGTile
            padding="small"
            appearance="primary"
            data-testid="feed-impact-option"
            style={{ cursor: 'pointer' }}
            onClick={() => props.selectOption({ ...props.data })}>
            <FGStack alignItems="center" gap={4}>
                <FGCheckbox isChecked={isSelected} />
                <EventCircle
                    color={get('color', data)}
                    style={{ marginLeft: 4 }}
                />
                <FGTypography
                    variant="body3-short"
                    tag="label"
                    color="strong"
                    cssStyle={{ pointerEvents: 'none' }}>
                    {label}
                </FGTypography>
            </FGStack>
        </FGTile>
    );
};
export default ImpactFilter;
